import { SortOrder } from 'baby-ui/lib/SortOrder'

export const DEFAULT_SORT_OPTION = 'Lowest price'
export const MOBILITY_SORT_PATH = 'sortableData.mobility.score'
export const PRICE_SORT_PATH = 'sortableData.price'
export const RATING_SORT_PATH = 'sortableData.rating'
export const SUCTION_SORT_PATH = 'sortableData.suction.score'
export const USER_REVIEW_COUNT_SORT_PATH = 'sortableData.reviewCount'

export const SORT_OPTIONS = {
  'Lowest price': {
    path: PRICE_SORT_PATH,
    direction: SortOrder.Asc,
  },
  'Highest price': {
    path: PRICE_SORT_PATH,
    direction: SortOrder.Desc,
  },
  'Highest user rating': {
    path: RATING_SORT_PATH,
    direction: SortOrder.Desc,
  },
  'Most reviewed': {
    path: USER_REVIEW_COUNT_SORT_PATH,
    direction: SortOrder.Desc,
  },
  'Best mobility': {
    path: MOBILITY_SORT_PATH,
    direction: SortOrder.Desc,
  },
  'Best suction': {
    path: SUCTION_SORT_PATH,
    direction: SortOrder.Desc,
  },
}
